import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { ListingService } from 'src/app/_shared/service/listings.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-create-mail-sheet',
  templateUrl: './create-mail-sheet.component.html',
  styleUrls: ['./create-mail-sheet.component.scss'],
})
export class CreateMailSheetComponent implements OnInit {
  onDestroyNotifier$ = new Subject();
  openCreateMailSheetValue = false;
  user: any;
  clientDetails: any;
  mailForm: FormGroup;
  mailFrom = new FormControl();
  mailSheetContext: any;
  selectedFiles: any;
  autoCompleteInput: any;
  @ViewChild('searchField') searchField: any;
  propertyAttachments = [];
  propertySelected: any;
  totalPropertyString: any;
  sendingMailInProgress: boolean = false;
  @Output() answerEvent = new EventEmitter<any>();
  property: any;
  detailsRequired = false;
  addressComponents = [];
  isMailDisabled: boolean;
  emailList: any;
  @Input() config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Create your mail content here',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
  };
  visibleEmails: any[] = [];
  selectedEmail: any = null;
  isShowUpdateClientSection: boolean = false;
  visibleName: any;
  selectedName: any = null;
  pastClientOption: any;
  selectedOption: any;

  fieldConfigMap = {
    name: {
      selectedKey: 'selectedName',
      visibleKey: 'visibleName',
      formKey: 'toName',
      valueKey: 'name',
    },
    email: {
      selectedKey: 'selectedEmail',
      visibleKey: 'visibleEmails',
      formKey: 'toEmail',
      valueKey: 'email',
    },
  };
  constructor(
    private clientDashboardState: ClientDashboardState,
    public formBuilder: FormBuilder,
    private clientDashboardService: ClientDashboardService,
    private snackBar: MatSnackBar,
    private userState: UserState,
    private listingService: ListingService
  ) {}

  ngOnInit(): void {
    this.mailForm = this.formBuilder.group({
      toEmail: [''],
      subject: ['', Validators.required],
      content: ['', Validators.required],
      toName: ['', Validators.required],
    });
    this.clientDashboardState.openCreateMailSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openCreateMailSheetValue = status;
    });
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((userDetails) => {
      this.user = userDetails;
    });
    this.clientDashboardState.activeClientDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.clientDetails = res;
    });

    this.clientDashboardState.mailSheetContext$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.mailSheetContext = res;
        if (this.mailSheetContext?.source == 'past-clients') {
          this.emailList = [
            {
              key: 'clientOneEmail',
              nameKey: 'clientOneName',
              label: 'Client',
              email: res.data?.clientOneEmail || '',
              name: `${res.data?.clientOneFirstName || ''} ${res.data?.clientOneLastName || ''}`.trim(),
            },
            {
              key: 'clientTwoEmail',
              nameKey: 'clientTwoName',
              label: 'Client2',
              email: res.data?.clientTwoEmail || '',
              name: `${res.data?.clientTwoFirstName || ''} ${res.data?.clientTwoLastName || ''}`.trim(),
            },
            {
              key: 'currentOwnerOneEmail',
              nameKey: 'currentOwnerOneName',
              label: 'Owner',
              email: res.data?.currentOwnerOneEmail || '',
              name: `${res.data?.currentOwnerOneFirstName || ''} ${res.data?.currentOwnerOneLastName || ''}`.trim(),
            },
            {
              key: 'currentOwnerTwoEmail',
              nameKey: 'currentOwnerTwoName',
              label: 'Owner2',
              email: res.data?.currentOwnerTwoEmail || '',
              name: `${res.data?.currentOwnerTwoFirstName || ''} ${res.data?.currentOwnerTwoLastName || ''}`.trim(),
            },
          ];
        }
        if (this.mailSheetContext?.source == 'expired-listings') {
          this.emailList = [
            {
              key: 'ownerEmail',
              nameKey: 'ownerName',
              label: 'Owner',
              email: res.data?.ownerEmail || '',
              name: res.data?.OwnerName || '',
            },
          ];
        }
        let emails = this.emailList.filter((x) => x.email);
        // this.pastClientOption = emails.length
        //   ? emails
        //   : ['clientOneEmail', 'currentOwnerOneEmail'].map((type) => this.emailList.find((x) => x.key.includes(type)));
        if (this.mailSheetContext?.source === 'past-clients') {
          this.pastClientOption = emails.length
            ? emails
            : ['clientOneEmail', 'currentOwnerOneEmail']
                .map((type) => this.emailList.find((x) => x.key.includes(type)))
                .filter(Boolean);
        } else {
          this.pastClientOption = this.emailList;
        }
        if (this.pastClientOption?.length === 1) {
          this.selectedOption = this.pastClientOption[0];
        }
        this.visibleName = this.emailList.filter((x) => x.name);
        this.visibleEmails = [...emails];
      }
    });
  }

  selected(item: any, type: 'name' | 'email') {
    const config = this.fieldConfigMap[type];
    const selected = this[config.selectedKey];
    let visibleList = this[config.visibleKey];
    const formControl = this.mailForm.get(config.formKey);
    if (selected) {
      visibleList.push(selected);
    }
    this[config.selectedKey] = item;
    this[config.visibleKey] = visibleList.filter((e) => e[config.valueKey] !== item[config.valueKey]);
    formControl.setValue(item[config.valueKey]);
    formControl.updateValueAndValidity();
    formControl.disable();
  }

  removeSelected(type: 'name' | 'email') {
    const config = this.fieldConfigMap[type];
    const selected = this[config.selectedKey];
    const formControl = this.mailForm.get(config.formKey);
    if (!selected) return;
    this[config.visibleKey].push(selected);
    formControl.setValue('');
    formControl.enable();
    this[config.selectedKey] = null;
  }

  closeCreateMailSheet() {
    this.isShowUpdateClientSection = false;
    this.clientDashboardState.openCreateMailSheetValue = false;
  }
  get mailFormControls() {
    return this.mailForm.controls;
  }

  sendMail() {
    if (!this.mailForm.controls.subject.value) {
      this.mailForm.controls.subject.setErrors({ message: 'Subject is required' });
      return;
    }
    if (!this.mailForm.controls.content.value) {
      this.mailForm.controls.content.setErrors({ message: 'Content is required' });
      return;
    }
    this.sendingMailInProgress = true;
    const emailFormData = new FormData();
    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        emailFormData.append(this.selectedFiles[i].name, this.selectedFiles[i]);
      }
    }

    emailFormData.append('content', this.mailForm.value.content);
    emailFormData.append('subject', this.mailForm.value.subject);

    if (this.propertyAttachments) {
      emailFormData.append('propertyAttachmentCount', this.propertyAttachments.length.toString());

      for (let i = 0; i < this.addressComponents.length; i++) {
        emailFormData.append('streetAddress' + i, this.addressComponents[i].streetAddress);
        emailFormData.append('city' + i, this.addressComponents[i].city);
        emailFormData.append('state' + i, this.addressComponents[i].state);
        emailFormData.append('zip' + i, this.addressComponents[i].zip);
      }
    }

    this.sendingMailInProgress = false;

    const formValue = this.mailForm.getRawValue();

    if (this.mailSheetContext.source == 'past-clients' || this.mailSheetContext.source == 'expired-listings') {
      emailFormData.append('email', formValue.toEmail || this.mailForm.value.toEmail);
    }
    const id =
      this.mailSheetContext?.source == 'past-clients' || this.mailSheetContext.source == 'expired-listings'
        ? formValue?.toEmail
        : this.clientDetails._id;

    this.clientDashboardService
      .sendMail(emailFormData, id, this.mailSheetContext?.source)
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        finalize(() => (this.sendingMailInProgress = false))
      )
      .subscribe({
        next: () => {
          if (this.mailSheetContext.source == 'past-clients' || this.mailSheetContext.source == 'expired-listings') {
            this.isShowUpdateClientSection = true;
          }
          // if (
          //   this.mailSheetContext?.source === 'past-clients' &&
          //   this.mailSheetContext.email !== this.mailForm.value.toEmail
          // ) {
          //   this.updatePastClientEmail();
          // }
          // this.resetForm();
        },
      });
  }

  updateClientDetails(selectedValue) {
    this.selectedOption = selectedValue;
  }

  update() {
    const email = this.mailForm.value.toEmail || this.selectedOption.email;
    const fullName = this.mailForm.value.toName || this.selectedOption.name;
    const paramsReq = {
      [this.selectedOption.key]: email,
      [this.selectedOption.nameKey]: fullName,
    };
    this.updatePastClientEmail(paramsReq);
  }

  cancel() {
    this.selectedOption = null;
    this.resetForm();
  }

  updatePastClientEmail(paramsReq: any) {
    if (this.mailSheetContext.source === 'expired-listings') {
      paramsReq = {
        ...paramsReq,
        ListingId: this.mailSheetContext?.data?.ListingId,
        userId: this.mailSheetContext?.data?.userId,
      };
      this.listingService.updateExpiredListingsOwnerData(paramsReq, 'mail').subscribe((res: any) => {
        this.resetForm();
      });
    } else {
      paramsReq = {
        ...paramsReq,
        address: this.mailSheetContext?.data?.address,
      };

      this.clientDashboardService.updateContactNoteSheet(paramsReq, 'email').subscribe((res: any) => {
        this.resetForm();
      });
    }
  }

  getAttachments(attachments) {
    this.selectedFiles = attachments;
  }

  getAddressComponents(property) {
    this.autoCompleteInput = property.fullAddress;
    this.propertySelected = property;
    if (
      !this.propertySelected.StreetAddress &&
      !this.propertySelected.City &&
      !this.propertySelected.State &&
      !this.propertySelected.PostalCode
    ) {
      this.openSnackBar('Search for a valid property.', 'snackbar-error');
    }
  }

  getPropertyDetails(params) {
    this.clientDashboardService.getPropertyDetails(params).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.property = {
            lstListPrice: response.data.basic.Lst_ListPrice,
            bedroomsTotal: response.data.basic.BedroomsTotal,
            bathroomsTotalInteger: response.data.basic.BathroomsTotalInteger,
            livingArea: response.data.basic.LivingArea,
            lotSizeSquareFeet: response.data.basic.LotSizeSquareFeet,
            address: response.data.basic.Address,
            lstListingId: response.data.basic.Lst_ListingId,
          };
          this.propertyAttachments.push(this.property);
        }
      },
      (err) => {
        this.openSnackBar('Property details fetching failed.', 'snackbar-error');
      }
    );
  }

  addProperty() {
    if (this.searchField.nativeElement.value) {
      let propertyTypes = ['basic', 'listing', 'avm'];
      if (this.addressComponents.length) {
        for (const i in this.addressComponents) {
          if (this.addressComponents[i].fullAddress == this.propertySelected.fullAddress) {
            this.openSnackBar('Same property cannot be attached again', 'snackbar-error');
            return;
          }
        }
      }
      let propertyObj = {
        address: {
          streetAddress: this.propertySelected.StreetAddress,
          city: this.propertySelected.City,
          state: this.propertySelected.State,
          zip: this.propertySelected.PostalCode,
          fullAddress: this.propertySelected.fullAddress,
        },
        type: propertyTypes,
      };
      this.addressComponents.push(propertyObj.address);
      this.getPropertyDetails(propertyObj);
      this.searchField.nativeElement.value = '';
      this.autoCompleteInput = '';
    }
  }

  removeSelectedProperty(index) {
    this.propertyAttachments.splice(index, 1);
    this.addressComponents.splice(index, 1);
  }

  private openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 5000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  resetForm() {
    this.mailForm.reset();
    this.clientDashboardState.openCreateMailSheetValue = false;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.clientDashboardState.mailSheetContextValue = null;
  }
}
